<template>
  <section class="my-modal-custom">
    <div class="align-center">
      <div class="container-modal animate__animated animate__fadeInDown">
        <div class="box-modal">
          <div class="modal-title">
            <h1>Exportar</h1>
            <feather class="feather-icon" type="x" size="14" @click="$emit('close')" />
          </div>
          <div class="box-container">
            <div class="itemselect" @click="$emit('select', 3)">
              <div class="field-nameinput">
                <h1>Nome:</h1>
                <b-input
                  v-model="nome"
                  expanded
                  class="inputname"
                  placeholder="Digite o nome do arquivo"
                />
              </div>
            </div>
            <div class="itemselect" @click="$emit('select', 1)">
              <div class="field-nameinput">
                <h1>Formato:</h1>
                <b-select
                  v-model="formato"
                  icon="file-table-outline"
                  class="inputname"
                  placeholder="Selecione um formato"
                  expanded
                >
                  <option value=".xls" selected>
                    .xls
                  </option>
                  <option value=".csv">
                    .csv
                  </option>
                </b-select>
              </div>
            </div>
          </div>
        </div>
        <div class="download-button" @click="download">
          <div class="content-download">
            <feather v-if="!downloadLoad" class="icon-downloas" type="download" size="15" />
            <div v-else class="loader-icon" />
            Baixar
          </div>
        </div>
      </div>
      <div />
    </div>
  </section>
</template>

<script>

export default {
	props: {
		downloadLoad: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			formato: '.xls',
			nome: '',
			calcular: false,
		};
	},
	methods: {
		download() {
			this.$emit('download', { formato: this.formato, nome: this.nome, calcular: this.calcular });
		},
	},
};

</script>

<style lang="scss" scoped>
.field-nameinput h1 {
  display: flex;
}
.content-download {
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader-icon {
  animation: is-rotating 1s infinite;
  border: 2px solid #CECECE;
  width: 15px;
  margin-right: 5px;
  border-top-color: #FF3B30;
  border-radius: 50%;
  height: 15px;
}

@keyframes is-rotating {
  to {
    transform: rotate(1turn);
  }
}

.inputname {
  width: 90%;
  margin-bottom: 15px;
}

.field-nameinput {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}
.align-center {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
.my-modal-custom {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.24);
  display: table;
  transition: all 0.5s ease;
  overflow-y: scroll;
  align-items: flex-end;
}
.feather-icon {
    background-color: #FF3B30;
    padding: 2px;
    border-radius: 50%;
    color:#FFF;
    cursor: pointer;
    transition: 300ms ease;
}
.feather-icon:hover {
     background-color: #cc342c;
}
.itemselect {
    width: 100%;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
}
.itemselect h1 {
      font-size: 12px;
     padding: 15px;
    width: 100%;
    height: 100%;
    transition: 500ms ease;
}
/* .itemselect h1:hover {
    transform: scale(1.1);
} */
.box-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: center;
    padding-bottom: 10px;
}
.modal-title {
    width: 100%;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid #dfdfe1c5;
}
.container-modal {
    position: absolute;
    width: 300px;
    border-radius: 5px;
}
.box-modal {
    background-color: #FFF;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 90%;
    border-radius: 10px;

}
.download-button {
  display: flex;
  align-items: center;
  justify-content: center;
    background-color: #007f00;
    padding: 10px;
    margin-top: 10px;
    border-radius: 10px;
    text-align: center;
    color: #FFF;
    cursor: pointer;
    transition: 500ms ease;
    font-size: 14px;
    position: relative;
}
.download-button:hover {
 background-color: #005c00;
}

.icon-downloas {
  margin-right: 5px;
}

</style>
